module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-11.8bd8a5ca.png";